// TDD-pending stub for the returnTo URL validator (#46 α-A12, Round 2.0 UX).
// Real home: `frontend/src/features/auth/lib/return-to.ts` (a criar) +
// echoes the contract de C46-UX-RETURNTO-* (querystring/fragment preserva,
// schemes não-http e hosts externos viram fallback `/`).
//
// API:
//   • validateReturnTo(input, opts) → string seguro (fallback default se
//     input falha em qualquer regra: external host, scheme não-http,
//     vazio, looping em /login ou /post-login).
//   • A função PRESERVA query e fragment de input válido — quem chamar
//     pode confiar no shape exato.

export const RETURN_TO_DEFAULT_FALLBACK = "/" as const;
export const REJECTED_RETURN_PATHS: readonly string[] = [
  "/login",
  "/post-login",
];

export interface ValidateReturnToOptions {
  readonly currentOrigin: string;
  readonly fallback?: string;
}

export function validateReturnTo(
  input: string,
  opts: ValidateReturnToOptions,
): string {
  const fallback = opts.fallback ?? RETURN_TO_DEFAULT_FALLBACK;
  if (input.trim() === "" || input.startsWith("//")) return fallback;
  try {
    const current = new URL(opts.currentOrigin);
    const parsed = new URL(input, current);
    if (parsed.origin !== current.origin) return fallback;
    if (parsed.protocol !== "http:" && parsed.protocol !== "https:") {
      return fallback;
    }
    if (REJECTED_RETURN_PATHS.includes(parsed.pathname)) return fallback;
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return fallback;
  }
}
